/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1LocationCitiesId200,
  GetApiV1LocationCitiesId401,
  GetApiV1LocationCitiesId404,
  GetApiV1LocationCitiesId500,
  GetApiV1LocationCitiesIdPathParams,
  GetApiV1LocationCitiesIdQueryResponse,
} from "../../types/locationCityController/GetApiV1LocationCitiesId.ts";
import { cityViewModelSchema } from "../cityViewModelSchema.ts";

export const getApiV1LocationCitiesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1LocationCitiesIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1LocationCitiesId200Schema = z.lazy(
  () => cityViewModelSchema,
) as unknown as ToZod<GetApiV1LocationCitiesId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1LocationCitiesId401Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCitiesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1LocationCitiesId404Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCitiesId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1LocationCitiesId500Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCitiesId500>;

export const getApiV1LocationCitiesIdQueryResponseSchema = z.lazy(
  () => getApiV1LocationCitiesId200Schema,
) as unknown as ToZod<GetApiV1LocationCitiesIdQueryResponse>;
